export default __webpack_public_path__ + "static/media/keto_flu@3x.693b3727.jpg";